<div class="form-group-query">
    <div [style]="props['labelstyle']">
        <label>{{to.label}}</label>
    </div>
    <div style="margin-left:10px">
        <input [checked]="isChecked" (change)="onCheckboxChange($event)" type="checkbox" />
    </div>
    <div style="margin-left:10px">
        <input type="text" (ngModelChange)="onInputChange()" [style]="style" [formlyAttributes]="field"
            [formControl]="formControl" class="ml-5 form-control"
            [ngClass]="{'input-invalid' : showError}" 
            appRenderWidth/>
        <formly-validation-message [field]="field" class="error-message"></formly-validation-message>
    </div>
</div>